import { FeaturedJob, flatFeaturedJob } from "../../types/featuredJobList";
import * as JobTypes from "../../types/jobData";

/**
 * Responsible for filtering featured jobs for conditions.
 *
 * Gets all active Filters and returns matching jobs.
 */
export class FeaturedJobsWorker {
  private sanitizedFilters: Record<string, Set<string>> = {};

  private currentActiveCategories: string[] = [];

  constructor(private featuredJobsConditions: flatFeaturedJob[], activeFilters: Record<string, Set<string>> = {}) {
    this.sanitizedFilters = this.sanitizeActiveFilters(activeFilters);
  }

  /**
   * Returns all featured job ID's that match exact the active filters.
   *
   * @returns {number[]} - Array of job IDs
   */
  findMatchingJobIDs(): number[] {
    let matchingFeaturedJobs = this.findMatchingJobs();
    let numArray = matchingFeaturedJobs.map((job) => {
      let int = parseInt(job.job_id);
      if (isNaN(int)) {
        console.error("Error converting job_id to number:", job.job_id);
        return 0; // or handle the error as needed
      }
      return int;
    });

    return numArray;
  }

  findMatchingJobs(): flatFeaturedJob[] {
    const matchingFeaturedJobs = this.featuredJobsConditions.filter((job) => {
      // 1. Check if Counts are equal
      let hasSameCount = this.checkJobCategoryCount(job);
      if (!hasSameCount) {
        return false;
      }

      // 2. Check if job matches all filters
      return this.checkFilters(job.categories);
    });

    return matchingFeaturedJobs;
  }

  /**
   * Because we have a Map Object with Set Values (e.g. WorkingTimes <set<string>> ), we need to count the single values.
   */
  countActiveSingleCategories(): number {
    let count = 0;
    let currentActiveCategories = [];
    for (const [key, value] of Object.entries(this.sanitizedFilters)) {
      for (const val of Array.from(value)) {
        count++;
        currentActiveCategories.push(val);
      }
    }
    this.currentActiveCategories = currentActiveCategories;
    console.log("currentActiveCategories:", this.currentActiveCategories); // Debugging output
    return count;
  }

  /**
   * Checks if job has same amount of categories as active filters
   */
  checkJobCategoryCount(job: flatFeaturedJob): boolean {
    const conditionCount = job.categories.length;

    if (this.countActiveSingleCategories() === conditionCount) return true;
    else return false;
  }

  /**
   * Checks if job matches all active filters
   *
   * We already know that the job has the same amount of categories as active filters.
   * Now we need to check if the job has all active filters.
   */
  checkFilters(jobCategories: string[]): boolean {
    const sanitizedJobCategories = jobCategories.map(this.sanitizeTitle);
    const sanitizedActiveCategories = this.currentActiveCategories.map(this.sanitizeTitle);
    console.warn("Sanitized Job Categories:", sanitizedJobCategories);
    console.warn("Sanitized Active Categories:", sanitizedActiveCategories);
    console.warn(
      "Chars sanitizedActiveCategories[0]:",
      sanitizedActiveCategories[0].split("").map((c) => c.charCodeAt(0))
    );
    console.warn(
      "Chars sanitizedJobCategories[0]:",
      sanitizedJobCategories[0].split("").map((c) => c.charCodeAt(0))
    );
    console.warn(
      "Sanitzed Comparison result: ",
      sanitizedActiveCategories.every((category) => sanitizedJobCategories.includes(category))
    );

    return sanitizedActiveCategories.every((category) => sanitizedJobCategories.includes(category)); // when has categorys return true
  }

  /* H E L P E R S */

  /**
   * Specified method to create a copy of the activeFilter Map Object with sanitized values.
   * @returns
   */
  sanitizeActiveFilters(rawFilters: Record<string, Set<string>>): Record<string, Set<string>> {
    const sanitizedFilters: Record<string, Set<string>> = {};

    for (const [key, valueSet] of Object.entries(rawFilters)) {
      const cleanedSet = new Set(Array.from(valueSet).map((val) => this.sanitizeTitle(val)));

      if (cleanedSet.size > 0) {
        sanitizedFilters[key] = cleanedSet;
      }
    }

    return sanitizedFilters;
  }

  /**
   * Like in PHP
   * @returns
   */
  sanitizeTitle(value: string): string {
    return String(value) // falls mal null/undefined kommt
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/Ä/g, "ae")
      .replace(/Ö/g, "oe")
      .replace(/Ü/g, "ue")
      .replace(/ß/g, "ss")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  }
}
